import { JOIST_COLOR } from '../../constants/colors'

export const getJoistBackgroundColor = (isDoubleJoist: boolean): string => {
    return isDoubleJoist ? JOIST_COLOR.BLUE : JOIST_COLOR.WHITE
}

export const getJoistTextColor = (isDoubleJoist: boolean): string => {
    return isDoubleJoist ? JOIST_COLOR.WHITE : JOIST_COLOR.BLACK
}
